import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const SecondPage = () => (
  <Layout>
    <SEO title="About eiriksm" />
    <h1>About eiriksm.dev and me</h1>
    <p></p>
  </Layout>
)

export default SecondPage
